import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonus" className="border-y border-grape/10 bg-white/70" data-id="element-17" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 py-12" data-id="element-18" data-mp="authf9yat5xk">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-19" data-mp="fteej0i979hs">
          🎁 5 Bonus Gratuiti Inclusi
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-plum/60" data-id="element-20" data-mp="1t3r67g5kd1d">
          Oltre all'ebook principale, ricevi anche questi regali — senza costi aggiuntivi.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-21" data-mp="3o3680bs3yueo">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-5 rounded-2xl border border-grape/20 bg-cream p-6" data-id="element-22" data-mp="3t1hm4ypfrr2p" data-mpi={i}>
              <img src={b.img} alt={`Copertina del bonus ${b.n}`} width={1024} height={1536} className="h-[140px] w-[94px] shrink-0 rounded-lg object-cover shadow-[0_10px_26px_-14px_rgba(46,16,101,0.55)] sm:h-[168px] sm:w-[112px]" style={{
            marginTop: "32px",
            marginBottom: "32px"
          }} data-id="element-23" data-mp="3detv2wmm8ut3" />
              <div className="flex min-w-0 flex-col" data-id="element-24" data-mp="2zgltucijr7c4">
                <div className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-25" data-mp="2ughameq97yi7">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-26" data-mp="2uiu0de297d5t">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-27" data-mp="33gnrmal5vgm4" /> Bonus {b.n}
                  </span>
                  <span className="text-sm font-bold" data-id="element-28" data-mp="npi46dhtlyt6">
                    <span className="text-plum/40 line-through" data-id="element-29" data-mp="no6rtpab7iqg">{b.price}</span>{' '}
                    <span className="text-blush-deep" data-id="element-30" data-mp="iqewelaghehi">GRATIS</span>
                  </span>
                </div>
                <h3 className="text-base font-bold leading-snug text-plum" data-id="element-31" data-mp="3cin1z4bsngei">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="3hgg51ohsvuak">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-blush/40 bg-blush-soft p-6 text-center" data-id="element-33" data-mp="3qj7kdzdsra7h">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-34" data-mp="2tsyl2f4s20i5">
            💰 Valore totale dei bonus: <span className="text-plum/50" data-id="element-35" data-mp="2xtqrl0m9lraq">116€</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-36" data-mp="2xua4g2x25phw">
              — OGGI GRATIS CON COREANO EXPRESSO
            </span>
          </p>
        </div>
      </div>
    </section>;
}